'use client'
import { useState, useEffect } from 'react'
import AirportDealsPreview from './AirportDealsPreview'

export default function HomeAirportPreview() {
  const [data, setData] = useState(null)

  useEffect(() => {
    fetch('/api/deals')
      .then(r => r.json())
      .then(d => setData(d))
      .catch(() => {})
  }, [])

  if (!data) return null
  return (
    <AirportDealsPreview
      suggestedOrigin={data.suggestedOrigin ?? null}
      originStats={data.originStats ?? {}}
      yearlyDealsByOrigin={data.yearlyDealsByOrigin ?? {}}
      historicalStats={data.historicalStats ?? {}}
    />
  )
}
